exports.NumberRange = [
  {
    id: "id",
    name: "id",
    type: "text",
    value: "",
    label: "Id",
    length: 12,
    key: "true",
  },
  {
    id: "universalDescriptor",
    name: "universalDescriptor",
    type: "text",
    value: "",
    label: "Universal Descriptor",
  },
  {
    id: "fromNumber",
    name: "fromNumber",
    type: "number",
    value: "",
    label: "From Number",
  },
  {
    id: "toNumber",
    name: "toNumber",
    type: "number",
    value: "",
    label: "To Number",
  },
  {
    id: "currentNumber",
    name: "currentNumber",
    type: "number",
    value: "",
    label: "Current Number",
  },
  {
    id: "prefix",
    name: "prefix",
    type: "text",
    value: "",
    label: "Prefix",
    Length: 5,
  },
  {
    id: "isExternal",
    name: "isExternal",
    type: "text",
    value: "",
    label: "External",
    Length: 1,
  },
  {
    id: "nameLocalizedText",
    name: "nameLocalizedText",
    type: "text",
    value: "",
    label: "nameLocalizedText",
  },
  {
    id: "createdBy",
    name: "createdBy",
    type: "text",
    label: "Created By",
    displayonly: "true",
    value: " ",
  },
  {
    id: "createdOn",
    name: "createdOn",
    type: "datetime",
    label: "Created On",
    displayonly: "true",
    value: " ",
  },
  {
    id: "modifiedBy",
    name: "modifiedBy",
    type: "text",
    label: "Modified By",
    displayonly: "true",
    value: " ",
  },
  {
    id: "modifiedOn",
    name: "modifiedOn",
    type: "datetime",
    label: "ModifiedOn",
    displayonly: "true",
    value: " ",
  },
];
